import HeadLayout from "@shared/layouts/HeadLayout";
import { Outlet } from "react-router-dom";

const AdminPage = () => {
  return (
    <>
      <HeadLayout title={"admin.administration"}></HeadLayout>
      <Outlet />
    </>
  );
};

export default AdminPage;
